import { render, staticRenderFns } from "./EpsCart.vue?vue&type=template&id=859df34c&scoped=true&"
import script from "./EpsCart.js?vue&type=script&lang=js&"
export * from "./EpsCart.js?vue&type=script&lang=js&"
import style0 from "./EpsCart.scss?vue&type=style&index=0&id=859df34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859df34c",
  null
  
)

export default component.exports